'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responseHeaders = exports.responseText = exports.responseBody = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _queryKey = require('../lib/query-key');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var responseBody = exports.responseBody = function responseBody(errorsState, queryConfig) {
  if (queryConfig) {
    var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

    return (0, _lodash2.default)(errorsState, [queryKey, 'responseBody']);
  }
};

var responseText = exports.responseText = function responseText(errorsState, queryConfig) {
  if (queryConfig) {
    var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

    return (0, _lodash2.default)(errorsState, [queryKey, 'responseText']);
  }
};

var responseHeaders = exports.responseHeaders = function responseHeaders(errorsState, queryConfig) {
  if (queryConfig) {
    var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

    return (0, _lodash2.default)(errorsState, [queryKey, 'responseHeaders']);
  }
};